import React from 'react';
import { Polyline as EPolyline } from './external/Polyline';

const Polyline = ({ route }) => {
  console.log('[Polyline Wrapper] Rendering with route:', route);
  return <EPolyline encodedPath={route.polyline} strokeWeight={4} strokeColor={route.color || '#4F8CE0'} />;
};

export default Polyline;
